import React from "react"
import { GetApp } from "../../App"
import { Ship } from "../../App/Ship"
import { GetShip } from "../../App/Context"
import { Block, BlockContainer, BlockField, BlockFieldInputsDivider, BlockRow } from "../../Components/Block"
import { ICruiseCalculations, IDayCalculations, ITripCalculations } from "../../Types"
import { StatsViewData } from "../StatsView"
import { PrintCalculationsViewProps } from "./Params"

export function PrintCalculationsView({ calculated }: PrintCalculationsViewProps) {
  const app = GetApp();
  const ship = GetShip();
  const t = app.getT("StatsView");
  const engines = Array.from({ length: ship.engineCount }, (_, i) => ({ name: `${i + 1}`, nmeaNumber: i + 1 }));
  // A single engine's value IS the total, so breaking it down printed every figure
  // twice (#1214) — mirror StatsView and only break down two or more engines.
  const engineBreakdown = engines.length > 1;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete calculations type
  const calcAny = calculated as any;
  const engineCalculated: ICruiseCalculations | IDayCalculations | ITripCalculations | undefined = calcAny.engineCalculated || calcAny;

  return (
    <BlockContainer className="PrintCalculationsView ">
      <Block className="Block-PrintCalculations block-field-270">
        <BlockRow>
          <BlockField label={t("time_total_paused_cruising")} className="">
            {app.format("timeh", calculated.duration)} <BlockFieldInputsDivider /> {app.format("timeh", calculated.durationPaused)} <BlockFieldInputsDivider /> {app.format("timeh", calculated.durationCruising)}
          </BlockField>
        </BlockRow>
        {engineCalculated && (
          <BlockRow className="">
            <BlockField
              label={engineBreakdown ? [t("duration_under_engine"), ...engines.map((engine) => t("duration_under_engine_name", { name: engine.name }))].join(" | ") : t("duration_under_engine")}
              style={engineBreakdown ? { maxWidth: `${ship.engineCount * 12}em` } : undefined}
              className=""
            >
              {app.format("timeh", calculated.durationUnderEngine)}
              {engineBreakdown && engines.map((e) => {
                return (
                  <React.Fragment key={e.nmeaNumber}> <BlockFieldInputsDivider /> {app.format("timeh", StatsViewData.engineValue(engineCalculated, e.nmeaNumber, "duration"))}
                  </React.Fragment>
                );
              })}
            </BlockField>
            {!engineBreakdown && <BlockField blank={true} />}
          </BlockRow>
        )}
        {Ship.isSailingVessel(ship) && (
          <BlockRow className="">
            <BlockField label={t("duration_under_sails")}>{app.format("timeh", calculated.durationUnderSails)}</BlockField>
            <BlockField blank={true} />
          </BlockRow>
        )}
      </Block>

      <Block className="Block-PrintCalculations block-field-270">
        <BlockRow className="">
          <BlockField label={t("distance_total")}>{app.format("distance", calculated.distance)}</BlockField>
          <BlockField blank={true} />
        </BlockRow>
        {engineCalculated && (
          <BlockRow>
            <BlockField
              label={engineBreakdown ? [t("distance_under_engine"), ...engines.map((engine) => t("distance_under_engine_name", { name: engine.name }))].join(" | ") : t("distance_under_engine")}
              style={engineBreakdown ? { maxWidth: `${ship.engineCount * 12}em` } : undefined}
            >
              {app.format("distance", calculated.distanceUnderEngine)}
              {engineBreakdown && engines.map((e) => {
                return (
                  <React.Fragment key={e.nmeaNumber}> <BlockFieldInputsDivider /> {app.format("distance", StatsViewData.engineValue(engineCalculated, e.nmeaNumber, "distance"))}
                  </React.Fragment>
                );
              })}
            </BlockField>
            {!engineBreakdown && <BlockField blank={true} />}
          </BlockRow>
        )}
        {Ship.isSailingVessel(ship) && (
          <BlockRow className="">
            <BlockField label={t("distance_under_sails")}>{app.format("distance", calculated.distanceUnderSails)}</BlockField>
            <BlockField blank={true} />
          </BlockRow>
        )}
      </Block>

      <Block className="Block-PrintCalculations block-field-270">
        <BlockRow>
          <BlockField label={t("speed")} className="">{app.format("speed", calculated.sog)}</BlockField>
        </BlockRow>
        {calcAny.daysRun !== undefined && (
          <BlockRow>
            <BlockField label={t("days_run")} className="">{app.format("distance", calcAny.daysRun)}</BlockField>
          </BlockRow>
        )}

      </Block>

    </BlockContainer>
  );
}
